import React from "react";
import "./home.css";
import ProfilePic from "./images/profilePic2.jpg";
import { Link } from "gatsby";
import NavBar from "./components/NavBar.js";
import facebook from "./images/facebook.svg";
import linkedin from "./images/linkedin.svg";
import youtube from "./images/youtube.svg";
import instagram from "./images/instagram.svg";
import twitter from "./images/twitter.svg";
import github from "./images/github.svg";
import gmail from "./images/gmail.svg";
import email from "./images/email.svg";
import phone from "./images/phone.svg";

import "./contact.css";

export default function Contact() {
  return (
    <body>
      <NavBar active="contact" />
      <div className="contactBody">
        <div>
          <h1 className="name">Contact Info</h1>
          <img className="profilePicContact" src={ProfilePic} />
        </div>
        <div>
          <h2>Email me at: </h2>
          <a className="email" href="mailto:karengao@mit.edu" target="_blank">
            <img title="school email" src={email} className="icon" />
            <p>karengao@mit.edu</p>
          </a>

          <a className="email" href="mailto:kgao103@gmail.com" target="_blank">
            <img title="gmail" src={gmail} className="icon" />
            <p>kgao103@gmail.com</p>
          </a>
          <div className="email">
            <img src={phone} className="iconDead" />
            <p>787.398.8296</p>
          </div>
          <p>405 Juan B Rodriguez Apt 5031</p>
          <p>San Juan, PR 00918</p>
          <Link to="https://www.linkedin.com/in/karen-g-b753ab98/">
            <img title="LinkedIn" src={linkedin} className="icon" />
          </Link>
          <Link to="https://www.facebook.com/karen.gao.731/">
            <img title="Facebook" src={facebook} className="icon" />
          </Link>
          <Link to="https://www.youtube.com/channel/UC1m6Zz6xttGOpExGNrW0IBA">
            <img title="Youtube" src={youtube} className="icon" />
          </Link>
          <Link to="https://www.instagram.com/karenro0/">
            <img title="instagram" src={instagram} className="icon" />
          </Link>
          <Link to="https://twitter.com/karenrooooo">
            <img title="twitter" src={twitter} className="icon" />
          </Link>
          <Link to="https://github.com/kgao2000">
            <img title="github" src={github} className="icon" />
          </Link>
        </div>
      </div>
    </body>
  );
}
